import { useNavigate } from "react-router-dom";
import DriverPartnerAuthGate from "@/components/mobile/DriverPartnerAuthGate";
import { saveDriverPartnerToken, completePartnerRegistration } from "@/lib/driverPartner";
import { enterStaffPortal, applyStaffPortalDocument } from "@/lib/staffPortal";

export default function DriverPartnerJoin() {
  const navigate = useNavigate();

  const onComplete = async (data) => {
    await completePartnerRegistration(data);
    if (data?.token) {
      saveDriverPartnerToken(data.token);
      enterStaffPortal("driver", window.location.origin + "/dd/hub");
      applyStaffPortalDocument("driver");
    }
    navigate("/dd/hub", { replace: true });
  };

  return <DriverPartnerAuthGate initialMode="signup" onComplete={onComplete} />;
}
